// clinician.js
import { SET_USER, RESET_USER, RESET_ERROR, SET_ERROR } from '../reducers/clinician'; // NEED TO PUT IN SET_ERROR AGAIN FOR LOGOUT FIX
import { callApiWithB2CToken } from './callApi';
import { msalConfig, tokenRequest, userInfoUrl } from '../config-client';

const Msal = require('msal');

const myMSALObj = new Msal.UserAgentApplication(msalConfig);

// set user by requesting user details from the /UserDetails endpoint from the express server
export const setUser = (userId) => {  
  // Logout code
  if (myMSALObj.getAccount() == null) {

    window.location.href = msalConfig.auth.postLogoutRedirectUri;

    return dispatch => {

        dispatch({ type: SET_USER, payload: null });

        dispatch({ type: SET_ERROR, payload: "Error: User not logged in"});

    };

  }

  return (dispatch) => {
    const url = userInfoUrl;
    // dispatch({ type: SET_USER });
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    return myMSALObj.acquireTokenSilent(tokenRequest)
      .then(tokenResponse =>
        callApiWithB2CToken(url, tokenResponse.accessToken, headers))
      .then((response) => {
        // if the response is an error then send an error message as the payload
        if (response.status !== 200 && response.status !== 201) {
          dispatch({ type: SET_USER, payload: { status: response.status } });
          return response.json();
        }
        return response.json();
      })
      .then((json) => {
        // this check is to make sure the object we are storing is what's in the resource object when
        // the GET /Patient from azure is returned (check on POSTMAN)
        if (json.resource !== undefined && json.resource !== null) {
          dispatch({ type: SET_USER, payload: json.resource });
        } else {
          dispatch({ type: SET_USER, payload: json });
        }
      })
      .catch(error => dispatch({ type: SET_USER, payload: null }));
  };
};

// reset user when they log out
export const resetUser = () => (dispatch) => {
  dispatch({
    type: RESET_USER,
    payload: null,
  });
};

// reset the error message once the page is reloaded
export const resetUserError = () => (dispatch) => {
  dispatch({
    type: RESET_ERROR,
    payload: null,
  });
};



// WEBPACK FOOTER //
// ./src/actions/clinician.js